import { useState, useEffect, useCallback } from "react";

const API_BASE = "/api";

// ── Sample data for development / demo ──
const SAMPLE_DATA = {
  nodes: [
    // Sectors
    { id: "s1", label: "Energy & Mining", type: "sector", size: 28 },
    { id: "s2", label: "Carbon Credits", type: "sector", size: 24 },
    { id: "s3", label: "Financial Services", type: "sector", size: 26 },
    { id: "s4", label: "Infrastructure", type: "sector", size: 22 },

    // Companies
    { id: "co1", label: "Globe Mining", type: "company", size: 20, sector: "s1" },
    { id: "co2", label: "ASI Group", type: "company", size: 22, sector: "s3" },
    { id: "co3", label: "Pakistan EV Corp", type: "company", size: 18, sector: "s2" },
    { id: "co4", label: "Meridian Capital", type: "company", size: 16, sector: "s3" },
    { id: "co5", label: "Sahel Development Fund", type: "company", size: 17, sector: "s4" },
    { id: "co6", label: "Vanguard Minerals", type: "company", size: 15, sector: "s1" },

    // Opportunities
    { id: "o1", label: "Malawi Mining JV", type: "opportunity", size: 16, value: 4500000, stage: "negotiation" },
    { id: "o2", label: "L30-ASI Joint Venture", type: "opportunity", size: 18, value: 2000000, stage: "structuring" },
    { id: "o3", label: "Pakistan EV Carbon Platform", type: "opportunity", size: 15, value: 3200000, stage: "pitch" },
    { id: "o4", label: "SWF Advisory Mandate", type: "opportunity", size: 14, value: 1800000, stage: "proposal" },
    { id: "o5", label: "Sahel Infrastructure Bond", type: "opportunity", size: 13, value: 5000000, stage: "early" },
    { id: "o6", label: "Private Debt Risk Assessment", type: "opportunity", size: 12, value: 950000, stage: "active" },
    { id: "o7", label: "Vanguard Exploration License", type: "opportunity", size: 11, value: 1200000, stage: "negotiation" },

    // Contacts
    { id: "c1", label: "James Hartley", type: "contact", size: 10, role: "Managing Director" },
    { id: "c2", label: "Amina Osei", type: "contact", size: 10, role: "CFO" },
    { id: "c3", label: "Ravi Patel", type: "contact", size: 10, role: "Head of Strategy" },
    { id: "c4", label: "Sarah Chen", type: "contact", size: 10, role: "Investment Director" },
    { id: "c5", label: "David Mwangi", type: "contact", size: 10, role: "Country Manager" },
    { id: "c6", label: "Elena Vasquez", type: "contact", size: 10, role: "Legal Counsel" },
    { id: "c7", label: "Tariq Rahman", type: "contact", size: 10, role: "Programme Lead" },
    { id: "c8", label: "Olivia Morgan", type: "contact", size: 10, role: "Portfolio Manager" },
  ],
  links: [
    // Company <-> Opportunity ownership
    { source: "co1", target: "o1", type: "ownership", label: "Client" },
    { source: "co2", target: "o2", type: "ownership", label: "JV Partner" },
    { source: "co3", target: "o3", type: "ownership", label: "Client" },
    { source: "co4", target: "o4", type: "ownership", label: "Client" },
    { source: "co5", target: "o5", type: "ownership", label: "Issuer" },
    { source: "co4", target: "o6", type: "ownership", label: "Client" },
    { source: "co6", target: "o7", type: "ownership", label: "Client" },

    // Company <-> Sector
    { source: "co1", target: "s1", type: "sector", label: "Sector" },
    { source: "co2", target: "s3", type: "sector", label: "Sector" },
    { source: "co3", target: "s2", type: "sector", label: "Sector" },
    { source: "co4", target: "s3", type: "sector", label: "Sector" },
    { source: "co5", target: "s4", type: "sector", label: "Sector" },
    { source: "co6", target: "s1", type: "sector", label: "Sector" },

    // Contact <-> Opportunity involvement
    { source: "c1", target: "o1", type: "involvement", label: "Lead" },
    { source: "c2", target: "o1", type: "involvement", label: "Finance" },
    { source: "c3", target: "o2", type: "involvement", label: "Strategy" },
    { source: "c4", target: "o4", type: "involvement", label: "Decision Maker" },
    { source: "c5", target: "o1", type: "involvement", label: "Local Ops" },
    { source: "c5", target: "o5", type: "involvement", label: "Local Ops" },
    { source: "c6", target: "o2", type: "involvement", label: "Legal" },
    { source: "c6", target: "o7", type: "involvement", label: "Legal" },
    { source: "c7", target: "o3", type: "involvement", label: "Programme" },
    { source: "c8", target: "o4", type: "involvement", label: "Portfolio" },
    { source: "c8", target: "o6", type: "involvement", label: "Analyst" },
    { source: "c1", target: "o7", type: "involvement", label: "Advisor" },

    // Contact <-> Company
    { source: "c1", target: "co1", type: "affiliation", label: "MD" },
    { source: "c2", target: "co1", type: "affiliation", label: "CFO" },
    { source: "c3", target: "co2", type: "affiliation", label: "Strategy" },
    { source: "c4", target: "co4", type: "affiliation", label: "Director" },
    { source: "c5", target: "co5", type: "affiliation", label: "Country Mgr" },
    { source: "c6", target: "co2", type: "affiliation", label: "Legal" },
    { source: "c7", target: "co3", type: "affiliation", label: "Lead" },
    { source: "c8", target: "co4", type: "affiliation", label: "PM" },

    // Referral chains
    { source: "c1", target: "c5", type: "referral", label: "Introduced" },
    { source: "c3", target: "c6", type: "referral", label: "Referred" },
    { source: "c4", target: "c8", type: "referral", label: "Introduced" },
    { source: "c1", target: "c4", type: "referral", label: "Introduced" },

    // Shared contacts across opportunities
    { source: "o1", target: "o7", type: "shared", label: "J. Hartley" },
    { source: "o4", target: "o6", type: "shared", label: "O. Morgan" },
    { source: "o1", target: "o5", type: "shared", label: "D. Mwangi" },
    { source: "o2", target: "o7", type: "shared", label: "E. Vasquez" },
  ],
};

/**
 * @param {Object} options
 * @param {boolean} options.useSampleData - Use built-in sample data instead of API
 */
export function useNetworkData({ useSampleData = false } = {}) {
  const [data, setData] = useState({ nodes: [], links: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (useSampleData) {
      setData(SAMPLE_DATA);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await fetch(`${API_BASE}/network-map`, {
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
      });

      if (!res.ok) throw new Error(`API returned ${res.status}`);

      const json = await res.json();
      setData({
        nodes: json.nodes || [],
        links: json.links || [],
      });
    } catch (err) {
      console.error("[NetworkMap] Failed to fetch data:", err);
      setError(err.message);
      if (import.meta.env.DEV) {
        setData(SAMPLE_DATA);
      }
    } finally {
      setLoading(false);
    }
  }, [useSampleData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}

export { SAMPLE_DATA };
